import { utils } from './-global.min.js'
const { getProductRecomendations } = utils

class NostoRecommendations extends HTMLElement {
  constructor() {
    super()
    this.productId = this.getAttribute('nosto-id')
    this.nostoPlacementId = this.getAttribute('nosto-placement-id') || false
    this.nostoSlotId = this.getAttribute('nosto-slot-id') || false

    if (this.nostoPlacementId) {
      this.waitForNostoToLoad()
    } else {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return
        observer.unobserve(this)

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div')
            html.innerHTML = text
            const recommendations = html.querySelector('nosto-recommendations')
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML
            }
          })
          .catch((e) => {
            console.error(e)
          })
      }

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this)
    }
  }

  async getProduct(url) {
    return await fetch(`${url}?section_id=api-product-card`).then(
      async (response) => {
        const product = await response.text()
        const fresh = document.createElement('div')
        fresh.innerHTML = product

        return fresh.querySelector('[data-api-content]').innerHTML
      }
    )
  }

  loopProducts(realSlotIdRendered, products, count = 0, shown = 0) {
    count = count ? count : products.length - 1
    let wrapper = this.querySelector('.scrollable-wrapper')

    wrapper.style.opacity = 0
    if (shown <= count) {
      fetch(`${products[shown].url}?section_id=api-product-card`).then(
        async (response) => {
          const product = await response.text()
          const fresh = document.createElement('div')
          fresh.innerHTML = product

          fresh
            .querySelector('a')
            .setAttribute(
              'href',
              `${fresh
                .querySelector('a')
                .getAttribute('href')}/?nosto=${realSlotIdRendered}`
            )

          fresh
            .querySelector('.card-information__wrapper > a')
            .setAttribute(
              'href',
              `${fresh
                .querySelector('.card-information__wrapper > a')
                .getAttribute('href')}/?nosto=${realSlotIdRendered}`
            )

          let slot = wrapper.querySelector('hh-scrollable-box').shadowRoot.querySelector('.scrollable-box__content').querySelector('slot[name=item]')
          slot.assignedNodes()[shown].innerHTML = fresh.querySelector('[data-api-content]').innerHTML

          shown++
          this.loopProducts(realSlotIdRendered, products, count, shown)
        }
      )
    } else {
      wrapper.style.opacity = 1
    }
  }

  async getRecommendedProducts() {
    if (this.nostoPlacementId && window.nostojs) {
      window.nostojs((api) => {
        api
          .defaultSession()
          .viewOther()
          .setPlacements(
            this.nostoPlacementId
              ? [this.nostoPlacementId]
              : api.placements.getPlacements()
          )
          .load()
          .then(async (response) => {
            const { recommendations } = response.campaigns

            let products = {}
            let realSlotIdRendered = ''

            if (this.nostoPlacementId) {
              products = recommendations[this.nostoPlacementId].products
              realSlotIdRendered =
                recommendations[this.nostoPlacementId].result_id
            } else {
              for (const property in recommendations) {
                if (
                  recommendations[property]['title'].includes(
                    'You Might Also Like'
                  ) ||
                  recommendations[property]['title'].includes(
                    'Still Interested In These?'
                  )
                ) {
                  products = recommendations[property].products
                  realSlotIdRendered = recommendations[property].result_id
                  break
                }
              }
            }

            if (products.length > 0) {
              this.style.display = 'block'
              this.loopProducts(realSlotIdRendered, products)
            } else {
              this.style.display = 'none'
            }
          })
      })

      return
    }

    const productRecommendations = await getProductRecomendations({
      product_id: this.productId,
      limit: 1,
      intent: 'related',
    })

    if (productRecommendations.products.length === 0) return
  }

  waitForNostoToLoad() {
    let limitInterval = 0
    const checkInterval = setInterval(() => {
      if (typeof window.nostojs === 'function') {
        this.getRecommendedProducts()
        clearInterval(checkInterval)
      } else if (limitInterval >= 10) {
        this.getRecommendedProducts()
        clearInterval(checkInterval)
      }

      limitInterval++
    }, 1000)
  }
}

customElements.define('nosto-recommendations', NostoRecommendations)
